import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-271b12a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "Service-Intr-com"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "服务介绍", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "云起无垠软件开发安全咨询团队经过多年的研究与实践，采用系统化的软件安全解决思路，从安全威胁入手，以逐步消减安全威胁为目的，在软件的需求、设计、开发、测试、上线运营等各阶段全流程落地安全化策略，确保安全威胁在每个阶段得到消减，保证业务系统上线安全。", -1));
const _hoisted_4 = {
  class: "frame-box"
};
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h5 data-v-271b12a8>安全开发体系框架</h5><div class=\"module\" data-v-271b12a8><p class=\"module-title\" data-v-271b12a8>DevOps</p><div class=\"module-content\" data-v-271b12a8><div class=\"label-box\" data-v-271b12a8><div class=\"label5 moblie-label4\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>编码</div></div></div><div class=\"label5 moblie-label4\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>提交</div></div></div><div class=\"label5 moblie-label4\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>编译</div></div></div><div class=\"label5 moblie-label4\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>自动化测试</div></div></div><div class=\"label5 moblie-label3\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>完整测试环境</div></div></div><div class=\"label5 moblie-label3\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>系统测试</div></div></div><div class=\"label5 moblie-label3\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>非功能测试</div></div></div><div class=\"label5 moblie-label3\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>用户验收测试</div></div></div><div class=\"label5 moblie-label3\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>发布</div></div></div><div class=\"label5 moblie-label3\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>运行</div></div></div></div></div></div>", 2);
const _hoisted_7 = {
  class: "module"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "module-title"
}, "传统模式", -1));
const _hoisted_9 = {
  class: "module-content"
};
const _hoisted_10 = {
  class: "label-box"
};
const _hoisted_11 = {
  class: "label6"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "class-type1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "in"
}, "需求")], -1));
const _hoisted_13 = {
  class: "next-icon"
};
const _hoisted_14 = {
  class: "label6"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "class-type1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "in"
}, "设计")], -1));
const _hoisted_16 = {
  class: "next-icon"
};
const _hoisted_17 = {
  class: "label6"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "class-type1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "in"
}, "开发")], -1));
const _hoisted_19 = {
  class: "next-icon"
};
const _hoisted_20 = {
  class: "label6"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "class-type1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "in"
}, "测试")], -1));
const _hoisted_22 = {
  class: "next-icon"
};
const _hoisted_23 = {
  class: "label6"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "class-type1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "in"
}, "上线")], -1));
const _hoisted_25 = {
  class: "next-icon"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label6"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "class-type1"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "in"
}, "运行")])], -1));
const _hoisted_27 = {
  class: "module"
};
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "module-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "class-type2"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "in"
}, "开发安全基本要求 ｜ 开发安全风险控制 ｜ 开发安全过程控制 ｜ 开发文档/源代码安全规定 ｜ 开发环境安全规定 ｜ 开发安全规定")])], -1));
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"module\" data-v-271b12a8><p class=\"module-title\" data-v-271b12a8>开发安全产品支撑</p><div class=\"module-content\" data-v-271b12a8><div class=\"line1\" data-v-271b12a8><div class=\"label-box newLabel\" data-v-271b12a8><div class=\"label label5\" data-v-271b12a8><div class=\"class-type1\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>Fuzzing</div></div></div><div class=\"label label5\" data-v-271b12a8><div class=\"class-type1\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>SAST</div></div></div><div class=\"label label5\" data-v-271b12a8><div class=\"class-type1\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>SCA</div></div></div><div class=\"label label5\" data-v-271b12a8><div class=\"class-type1\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>IAST</div></div></div><div class=\"label label5\" data-v-271b12a8><div class=\"class-type1\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>DAST</div></div></div></div></div><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8>开发全流程安全检测</div></div></div></div><div class=\"module\" data-v-271b12a8><p class=\"module-title\" data-v-271b12a8>开发安全阶段运营</p><div class=\"module-content\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8> 流程评审｜ 安全检测｜ 安全评估｜ 应急响应｜ 体系完善 </div></div></div></div><div class=\"module\" data-v-271b12a8><p class=\"module-title\" data-v-271b12a8>开发安全知识赋能</p><div class=\"module-content\" data-v-271b12a8><div class=\"class-type2\" data-v-271b12a8><div class=\"in\" data-v-271b12a8> 安全需求分析｜ 威胁建模｜ 安全设计与实践｜ 安全意识培训｜ 安全流程培训｜ 安全编码培训｜ 渗透测试培训｜ 安全运维指南 </div></div></div></div>", 3);
import { MOBILE_FUNC } from '@/uitl/currencyFunc';
export default {
  __name: 'serviceIntr',
  setup(__props) {
    let isMobile = MOBILE_FUNC();
    console.log(isMobile);
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _withDirectives(_createElementVNode("i", _hoisted_13, null, 512), [[_directive_lazy, require('@/assets/img/global/next-icon.png'), "background-image"]])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _withDirectives(_createElementVNode("i", _hoisted_16, null, 512), [[_directive_lazy, require('@/assets/img/global/next-icon.png'), "background-image"]])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _withDirectives(_createElementVNode("i", _hoisted_19, null, 512), [[_directive_lazy, require('@/assets/img/global/next-icon.png'), "background-image"]])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _withDirectives(_createElementVNode("i", _hoisted_22, null, 512), [[_directive_lazy, require('@/assets/img/global/next-icon.png'), "background-image"]])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _withDirectives(_createElementVNode("i", _hoisted_25, null, 512), [[_directive_lazy, require('@/assets/img/global/next-icon.png'), "background-image"]])]), _hoisted_26])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", {
        class: "module-title",
        innerHTML: _unref(isMobile) ? '开发安全管理体系建设' : '开发安全<br />管理体系建设'
      }, null, 8, _hoisted_28), _hoisted_29]), _hoisted_30])]);
    };
  }
};